module.exports = __webpack_public_path__ + "img/person-sign.01ad0766.svg";